<template>
   <el-container class="content" style="display: block;position: relative;">
     <div style="width: 100%;background-color: #1a1a1a;z-index: 2;position: relative;" :style="{'width': screenWidth+'px','height':screenHeight*0.05+'px'}">
      <div class="xiaoguox-search">
        <input type="text" v-model="name" placeholder="搜索"  />
        <i class="el-icon-search xiaoguox-search-s" @click="search()"></i>
      </div>
      <div class="xiaoguox-info">
        <span class="xiaoguox-info-text" style="right: 225px;top: 9px;">
          <img src="https://images.yoooooo.com/yzzmshouye/data.png" @click="back()" />
        </span>
        <span class="xiaoguox-info-text" style="right: 105px;">18520599388</span>
        <span class="xiaoguox-info-text" style="right: 45px;top: 11px;">
          <img src="https://images.yoooooo.com/yzzmshouye/filter.png" @click="back()" />
        </span>
        <span class="xiaoguox-info-text" style="right: 5px;top: 10px;">
          <img src="https://images.yoooooo.com/yzzmshouye/exit.png" @click="back()" />
        </span>
        
      </div>
     </div>
     <div style="width: 100%;background-color: #212121;z-index: 2;position: relative;overflow: scroll;" :style="{'width': screenWidth+'px','height':screenHeight*0.8+'px'}">
        <div class="avatar-grid">
            <div class="avatar-item" v-for="(item, index) in list" :key="index">
              <div class="avatar-box" v-if="item.name=='添加'" @click="addXx()">
                <img :src="item.img" alt="avatar" class="avatarimgadd" />
              </div>
              <div class="avatar-box" v-else>
                <img :src="item.img" alt="avatar" class="avatar-img"  v-if="item.img" />
              </div>
              <div class="avatar-label">{{ item.name }}</div>
            </div>
          </div>
     </div>
    <div class="xiaoguox-add" v-if="addType>0">
      <div class="xiaoguox-add-search">
        <input type="text" v-model="searchName" placeholder="搜索" @keyup.enter="search()" />
        <i class="el-icon-search xiaoguox-add-search-s" @click="search()"></i>
      </div>
      <div class="xiaoguox-add-submit">
        <button class="add-button" @click="submits()">确认</button>
      </div>
      <div class="xiaoguox-add-back" v-if="addType==2">
        <img src="https://images.yoooooo.com/yzzmshouye/back.png" @click="back()" />
        <!-- <button class="add-button" @click="addType==2">确认</button> -->
      </div>
      <div class="xiaoguox-adds" style="position: relative;overflow: scroll;" v-if="addType==1">
        <div class="avatar-grid1">
              <div class="avatar-item1" v-for="(item, index) in listAdd" :key="index" @click="choseAdd(item.id,1)">
                <div class="avatar-box1" :class="{addChose:item.id==choseId}">
                  <img :src="item.img" alt="avatar" class="avatar-img1" v-if="item.img" />
                </div>
                <div class="avatar-label1">{{ item.namech }}</div>
              </div>
        </div>
      </div>

      <div class="xiaoguox-adds" style="position: relative;overflow: scroll;" v-if="addType==2">
        <div class="avatar-grid1">
              <div class="avatar-item1" v-for="(item, index) in listZhu" :key="index" @click="choseAdd(item.id,2)">
                <div class="avatar-box2" :class="{addChose:item.id==choseIdz}">
                  {{ item.name }}
                </div>
                <!-- <div class="avatar-label1">{{ item.namech }}</div> -->
              </div>
        </div>
      </div>

    </div> 
    <div style="width: 100%;background-color: #1a1a1a;z-index: 2;position: relative;" :style="{'width': screenWidth+'px','height':screenHeight*0.15+'px'}">

    </div>






     <!-- <div class="beian">


      <a href="http://beian.miit.gov.cn/state/outPortal/loginPortal.action" rel="noreferrer" target="_blank" style="text-decoration:none;color: #fff;background-color: black;">粤ICP备2024237244号@2024 © 宇宙之幂</a>


     </div> -->








   </el-container>







</template>


<script>

  export default {
    data() {
      return {

        list:[],
        screenWidth : window.innerWidth,
        screenHeight : window.innerHeight,
        width:(window.innerWidth*1.1-31*6.5)/30,
        height:(window.innerWidth*1.1-31*6.5)/30,
        name:'',
        listAdd:[],
        listZhu:[],
        addType:0,
        searchName:'',
        choseId:0,
        choseIdz:0



      };
    },
    mounted() {

      },
      beforeDestroy() {

      },
    created() {

      this.loadList()
      
      this.getScreen()
      console.log(this.screenWidth,'width')

    },

	methods:{
    back(){
      this.searchName=''
      this.addType=1
      // this.loadListAdd()
    },
    search(){
    	if(this.addType==1){
    		this.loadListAdd()
    	}
      if(this.addType==2){
        this.loadListZhu()
      }
    },
    addXx(){
      this.addType=1
      this.loadListAdd()
    },
    submits(){
      this.searchName=''
      if(this.addType==1){
        this.loadListZhu()
        this.addType=2
      }else{
        this.addData()
      }
    },
    choseAdd(id,t){
      if(t==1){
      	this.choseId = id
      }else{
        this.choseIdz = id
      }
      
    },
    
    getScreen() {
      if(navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i )){
        window.location.href='http://m.universe.top/'

      }

    },


    loadList(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'get',
      	params:{
          name:this.name,
          p:this.page,

      	},
      	url:'https://tossp.yoooooo.com/index.php/index/data/loadyzzmlist'
      })
      .then(res=>{
        this.list = res.data.data;
        this.list.push({
        		name:'添加',
        		img:'https://images.yoooooo.com/yzzmshouye/add.png'
        	})
        for(let i = 0;i<100;i++){
        	this.list.push({
        		name:'',
        		img:''
        	})
        }


      })
      .catch(err=>{

      });
    },
    loadListAdd(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'get',
      	params:{
          name:this.searchName,
         

      	},
      	url:'https://tossp.yoooooo.com/index.php/index/data/loadListAdd'
      })
      .then(res=>{
        this.listAdd = res.data.data;
        


      })
      .catch(err=>{

      });
    },
    loadListZhu(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'get',
      	params:{
          name:this.searchName,
         

      	},
      	url:'https://tossp.yoooooo.com/index.php/index/data/loadyzzmlistZhu'
      })
      .then(res=>{
        this.listZhu = res.data.data;
        


      })
      .catch(err=>{

      });
    },
    addData(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'get',
      	params:{
          userId:1,
          id:this.choseId,
          idz:this.choseIdz,

      	},
      	url:'https://tossp.yoooooo.com/index.php/index/data/yzzmlistAdd'
      })
      .then(res=>{
        this.loadList()
        this.addType=0
        this.choseId=0
        this.choseIdz=0
        


      })
      .catch(err=>{

      });
    },
		msg(msg,type){
			this.$message({
			  message: msg,
			  type: type
			});
		},



	}


  }
</script>
<style>

.xiaoguox-add{
  background-color: #1e1e1e;
  position: absolute;
  height: 60%;
  width: 50%;
  border: 3px solid #333;
  border-radius: 20px;
  z-index: 800;
  top: 16%;
  left: 25%;
  padding: 40px 0 0 0;
	
}
.xiaoguox-adds{
  background-color: #333;
  position: absolute;
  height: 90%;
  width: 94%;
  border: 3px solid #1e1e1e;
  border-radius: 20px;
  z-index: 800;
  top: 5%;
  left: 3%;
	
}
.xiaoguox-add-submit{
	height: 5%;
  width: 40%;
  top: 2%;
  right: 3%;
  position: absolute;
}
.xiaoguox-add-back{
	height: 5%;
  /* width: 40%; */
  top: 2.5%;
  left: 1%;
  position: absolute;
}
.add-button {
  background-color: #4e6bf5;
  color: white;
  padding: 10px 20px;
  float: right;
  border-radius: 10px;
}
.xiaoguox-add-search{
  height: 5%;
  width: 40%;
  top: 2%;
  left: 4%;
  position: absolute;
  
  
}
.xiaoguox-add-search input{
  height: 100%;
  width: 100%;
  border-radius: 10px;
  padding-left: 10px;
}
.xiaoguox-add-search-s{
  position: absolute;
  top: 21%;
  right: 5px;
  z-index: 10;
  font-size: 24px;
}
.xiaoguox-info{
  height: 50%;
  width: 10%;
  top: 20%;
  right: 10px;
  position: absolute;
  
  
}
.xiaoguox-info-text{
  color: #fff;
  font-size: 1.4rem;
  position: absolute;
  top: 5px;
}

.xiaoguox-search{
  height: 50%;
  width: 19%;
  top: 20%;
  left: 100px;
  position: absolute; 
  
}
.xiaoguox-search input{
  height: 100%;
  width: 100%;
  border-radius: 10px;
  padding-left: 10px;
}
.xiaoguox-search-s{
  position: absolute;
  top: 21%;
  right: 5px;
  z-index: 10;
  font-size: 24px;
}


.avatar-grid1 {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
    gap: 23px;
    /* background-color: #1e1e1e; */
    padding: 20px 40px;
    border-radius: 10px;
  }

  .avatar-item1 {
    background: #2a2a2a;
    border-radius: 12px;
    text-align: center;
    /* padding: 10px; */
    position: relative;
    width: 100%;
    padding-top: 100%; /* 高度 = 宽度，形成正方形 */
    /* overflow: hidden; */
  }
  .avatar-label1 {
    position: absolute;
    /* top: 0; */
    bottom: -20px;
    width: 100%;
    font-size: 14px;
    color: #f0f0f0;
  }
.avatar-box1 {
  width: 100%;           /* 父容器宽度自适应 */
  height: 120px;         /* 固定高度，你可以按需调整 */
  display: flex;
  justify-content: center;  /* 水平居中 */
  align-items: center;      /* 垂直居中（如果需要） */
  background-color: #222;   /* 可选背景 */
  overflow: hidden;         /* 避免溢出 */
  border-radius: 10px;      /* 可选圆角 */
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
.avatar-box2 {
  width: 100%;           /* 父容器宽度自适应 */
  height: 120px;         /* 固定高度，你可以按需调整 */
  display: flex;
  justify-content: center;  /* 水平居中 */
  align-items: center;      /* 垂直居中（如果需要） */
  background-color: #222;   /* 可选背景 */
  overflow: hidden;         /* 避免溢出 */
  border-radius: 10px;      /* 可选圆角 */
  color: #fff;
  font-size: 1.4rem;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
.addChose{
	background-color: rgb(166, 168, 168);
}
.avatar-img1 {
  height: 100%;
  width: auto;             /* 宽度自适应 */
  object-fit: contain;     /* 不裁剪，完整显示；也可改为 cover 裁剪居中 */
}


  .avatar-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
    gap: 20px;
    background-color: #1e1e1e;
    padding: 40px 100px;
    border-radius: 10px;
  }

  .avatar-item {
    background: #212121;
    border-radius: 12px;
    text-align: center;
    /* padding: 10px; */
    position: relative;
    width: 100%;
    padding-top: 100%; /* 高度 = 宽度，形成正方形 */
  }

.avatar-box {
  width: 100%;           /* 父容器宽度自适应 */
  height: 150px;         /* 固定高度，你可以按需调整 */
  display: flex;
  justify-content: center;  /* 水平居中 */
  align-items: center;      /* 垂直居中（如果需要） */
  background-color: #333;   /* 可选背景 */
  overflow: hidden;         /* 避免溢出 */
  border-radius: 10px;      /* 可选圆角 */
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.avatar-img {
  height: 100%;
  width: auto;             /* 宽度自适应 */
  object-fit: contain;     /* 不裁剪，完整显示；也可改为 cover 裁剪居中 */
}
.avatarimgadd {
  height: 50%;
  width: auto;             /* 宽度自适应 */
  object-fit: contain;     /* 不裁剪，完整显示；也可改为 cover 裁剪居中 */
}
  .avatar-label {
    position: absolute;
    /* top: 0; */
    bottom: -20px;
    width: 100%;
    font-size: 14px;
    color: #f0f0f0;
  }
</style>
<style>



  .beian {
    position: fixed; /* 定位为固定位置，覆盖整个视窗 */
    color: #616161;
    /* top: 0; */
    left: 42%;
    /* right: 0; */
    bottom: 0;

    z-index: 1000; /* 确保蒙层在其他内容之上 */
  }

  .content{
  	background: #939AA0;
  	width: 100%;
  	height: 100%;
  }
  body {
  overflow-x:hidden;
  overflow-y:hidden;
  }
  .el-scrollbar__wrap{
    background-color: black;
  }







</style>



// WEBPACK FOOTER //
// src/components/main/xiaoguox.vue